"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionDeleteCtrl = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var modal_form_component_1 = require("../../components/modal.form/modal.form.component");
var notification_service_1 = require("../../components/notification.toast/notification.service");
var index_1 = require("../../i18n/index");
var index_2 = require("../../services/index");
var render_service_1 = require("../../services/render.service");
var page_state_1 = require("../../state/page.state");
/** Protect users from deleting all of their data */
var MAX_TAG_COUNT = 5;
exports.CollectionDeleteCtrl = {
    get selectedCount() {
        return page_state_1.CurrentState.Tag.collections.length;
    },
    canDisplay: function () {
        return index_2.Services.Token.has(core_api_1.IkeToken.COLLECTION_DELETE);
    },
    canDelete: function () {
        if (!exports.CollectionDeleteCtrl.canDisplay()) {
            return false;
        }
        var selectedTagIds = page_state_1.CurrentState.Tag.tags;
        return selectedTagIds.length > 0 && selectedTagIds.length <= MAX_TAG_COUNT;
    },
    showConfirmModal: function () {
        if (!exports.CollectionDeleteCtrl.canDelete()) {
            exports.CollectionDeleteCtrl.rejectCollectionDelete();
            return;
        }
        var confirmModal = new CollectionDeleteConfirmModal({
            title: index_1.T.COLLECTION_DELETE_TITLE,
            confirm: index_1.T.COLLECTION_DELETE,
            success: {
                key: index_1.T.COLLECTION_DELETE_SUCCESS,
                attrs: {
                    count: exports.CollectionDeleteCtrl.selectedCount
                }
            }
        });
        confirmModal.open();
    },
    deleteCollections: function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var collectionSummaries;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!exports.CollectionDeleteCtrl.canDelete()) {
                            throw Error('Cannot delete collections');
                        }
                        collectionSummaries = page_state_1.CurrentState.Tag.collections;
                        return [4 /*yield*/, index_2.Services.Collection.remove(collectionSummaries)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    },
    rejectCollectionDelete: function () {
        notification_service_1.NotificationService.warn({
            key: index_1.T.COLLECTION_DELETE_REJECT,
            attrs: {
                max: MAX_TAG_COUNT
            }
        });
    }
};
var CollectionDeleteConfirmModal = /** @class */ (function (_super) {
    tslib_1.__extends(CollectionDeleteConfirmModal, _super);
    function CollectionDeleteConfirmModal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(CollectionDeleteConfirmModal.prototype, "nodes", {
        get: function () {
            return (0, render_service_1.m)('p', (0, index_1.Translate)(index_1.T.COLLECTION_DELETE_CONFIRM, exports.CollectionDeleteCtrl.selectedCount));
        },
        enumerable: false,
        configurable: true
    });
    CollectionDeleteConfirmModal.prototype.submit = function () {
        return exports.CollectionDeleteCtrl.deleteCollections();
    };
    return CollectionDeleteConfirmModal;
}(modal_form_component_1.ModalFormComponent));
//# sourceMappingURL=collection.delete.ctrl.js.map